import type { EvaluationType, EvaluationType_Option } from "../types";

interface EvaluationTypeSectionProps {
  isDark: boolean;
  selectedType: EvaluationType;
  evaluationTypes: EvaluationType_Option[];
  onTypeChange: (type: EvaluationType) => void;
}

export const EvaluationTypeSection: React.FC<EvaluationTypeSectionProps> = ({
  isDark,
  selectedType,
  evaluationTypes,
  onTypeChange,
}) => {
  return (
    <div className="col-span-full bg-(--card-bg) border border-(--border-color) rounded-2xl p-6 shadow-sm mb-2">
      <label className="block text-xs font-bold uppercase tracking-wider mb-4 text-(--text-tertiary)">
        Tipo de Atividade
      </label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {evaluationTypes.map((type) => (
          <button
            key={type.id}
            onClick={() => onTypeChange(type.id)}
            className="p-4 rounded-xl border-2 flex flex-col items-center gap-3 transition-all group relative overflow-hidden active:scale-95"
            style={
              selectedType === type.id
                ? {
                    borderColor: "var(--primary-color)",
                    backgroundColor: "rgba(25, 103, 210, 0.04)",
                  }
                : {
                    borderColor: "var(--border-color)",
                    backgroundColor: "transparent",
                  }
            }
          >
            <div
              className={`p-2 rounded-lg transition-colors ${
                selectedType === type.id
                  ? "bg-blue-100 text-(--primary-color)"
                  : "bg-gray-100 text-(--text-tertiary) group-hover:bg-blue-50 group-hover:text-(--primary-color)"
              }`}
            >
              <type.icon className="w-5 h-5" />
            </div>
            <span
              className={`text-xs font-bold text-center transition-colors ${
                selectedType === type.id
                  ? "text-(--primary-color)"
                  : "text-(--text-secondary) group-hover:text-(--primary-color)"
              }`}
            >
              {type.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
